import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { FlashList } from '@shopify/flash-list';
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import SearchHistories from '@/screens/SearchScreen/components/SearchHistories';
import SearchItemSummary from '@/screens/SearchScreen/components/SearchItemSummary';
import SearchLoading from '@/screens/SearchScreen/components/SearchLoading';
import SearchNoResult from '@/screens/SearchScreen/components/SearchNoResult';
import SearchExplore from './SearchExplore';
import SearchRecommendKeyword from './SearchRecommendKeyword';
import SearchRecommendPlace from './SearchRecommendPlace';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
export default function SearchSummaryView({ searchResults, onQueryUpdate, onItemSelect, isLoading, }) {
    return (_jsx(Container, { children: isLoading ? (_jsx(SearchLoading, {})) : searchResults === null ? (_jsx(_Fragment, { children: _jsxs(ScrollView, { bounces: false, style: {
                    backgroundColor: color.gray20,
                }, children: [_jsxs(SearchRecommendContainer, { children: [_jsx(SearchHistories, { onPressHistory: onQueryUpdate }), _jsx(SearchRecommendPlace, { onPressKeyword: onQueryUpdate }), _jsx(SearchRecommendKeyword, { onPressKeyword: onQueryUpdate })] }), _jsx(SearchExplore, {})] }) })) : searchResults.length === 0 ? (_jsx(SearchNoResult, {})) : (_jsx(ListWrapper, { children: _jsx(FlashList, { keyboardDismissMode: "on-drag", renderItem: ({ item }) => (_jsx(LogParamsProvider, { params: { place_id: item.place.id, place_name: item.place.name }, children: _jsx(ItemWrapper, { children: _jsx(SearchItemSummary, { item: item, onPress: () => onItemSelect(item) }) }, item.place.id) })), data: searchResults, estimatedItemSize: 108 }) })) }));
}
const Container = styled.View `
  flex: 1;
  background-color: ${color.white};
`;
const SearchRecommendContainer = styled.View `
  padding: 16px 16px 32px;
  gap: 32px;
  background-color: ${color.white};
`;
const ItemWrapper = styled.View `
  padding-bottom: 30px;
`;
const ListWrapper = styled.View `
  padding: 20px;
  flex: 1;
`;
